"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _sources = require("../../utils/sources");
var _types = require("./types");
function syncBannerStatus(bannerId) {
  return function (dispatch, getState) {
    var _getState = getState(),
      banners = _getState.banners;
    var updatedBanners = (0, _sources.toggleBannerStatus)(bannerId, banners);
    var action = {
      type: _types.BROADCAST_SYNC_BANNERS_STATUS,
      payload: {
        banners: updatedBanners
      }
    };
    dispatch(action);
  };
}
var _default = exports["default"] = syncBannerStatus;